import {ObjectDTO} from "./object-dto";

export class AtelierDTO extends ObjectDTO{

  id: number;
  libelle: string;
  actif:boolean;
  code:string;

}
